<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="['人员销售情况', $t('text.lineItem')]"></breadcrumb>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons> <span>*仅统计现结订单明细</span></template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        :span-method="mergeMethod"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="images" :title="$t('payment.total')">
          <template v-slot="{ row }">
            <span :class="row.total < 0 ? 'red' : 'green'">
              <currency :code="row.currency"></currency>
              {{ row.total }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="paidAt" :title="$t('payment.receiveAt')" />
        <vxe-table-column
          field="payMethodName"
          :title="$t('payment.payMethod')"
        />
        <vxe-table-column field="ownerName" :title="$t('payment.ownerName')" />
        <vxe-table-column field="serialNo" :title="$t('bargain.serialNo')">
          <template v-slot="{ row }">
            <div class="font10">
              <el-popover placement="right" width="600" trigger="click">
                <vxe-table
                  :data="row.orders"
                  ref="ordersTable"
                  class="recordsTable"
                  size="mini"
                  resizable
                  round
                  auto-resize
                  highlight-hover-row
                  :scroll-y="{ enabled: false }"
                >
                  <vxe-table-column
                    field="serialNo"
                    :title="$t('order.serialNo')"
                  />
                  <vxe-table-column
                    field="productNo"
                    :title="$t('product.productNo')"
                  >
                    <template v-slot="{ row }">
                      {{ row.productNo }}
                      <div class="font10">{{ row.color }} {{ row.size }}</div>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="quantity"
                    :title="$t('text.quantity')"
                  >
                    <template v-slot="{ row }">
                      {{ row.quantity }}{{ row.unit }}
                    </template>
                  </vxe-table-column>

                  <vxe-table-column field="price" :title="$t('order.price')">
                    <template v-slot="{ row }">
                      <currency :code="row.currency"></currency>
                      {{ row.price }}
                      <small
                        v-if="row.discountRate != null && row.discountRate != 0"
                        >({{ row.discountRate }}%)</small
                      >
                      <div
                        v-if="row.extraCharge != null && row.extraCharge != 0"
                        class="font10"
                      >
                        {{ $t("order.extraChargeSimple") }}:
                        <currency :code="row.currency"></currency>
                        {{ row.extraCharge }}
                      </div>
                    </template>
                  </vxe-table-column>
                  <vxe-table-column
                    field="createAt"
                    :title="$t('text.createAt')"
                    width="110"
                  />
                </vxe-table>
                <span slot="reference" class="popover-reference">
                  {{ row.serialNo }}
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payAmount" :title="$t('bargain.payAmount')">
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.payAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" :title="$t('bargain.amount')">
          <template v-slot="{ row }">
            <span class="font16">
              <currency
                v-if="row.amount != null"
                :code="row.currency"
              ></currency>
              {{ row.currentMonthAmount }}
            </span>
            <div class="font10">
              <currency :code="row.currency"></currency>
              {{ row.amount }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="customerName" :title="$t('menu.customers')" />
        <vxe-table-column field="_ownerName" :title="$t('text.owner')">
          <template v-slot="{ row }">
            {{ row._ownerName }}
            <div class="font10">
              {{ row.shopName }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
      </vxe-table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Currency from "@/components/Currency";
import Payment from "@/api/payment.js";

export default {
  mixins: [page],
  components: { Currency },
  data() {
    return {
      Util: Util,
      searchForm: {
        createAtStartAt: null,
        createAtEndAt: null,
        ownerIds: [],
      },
      records: [],
      mergeCells: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    if (self.$route.query.data === "today") {
      self.searchForm.createAtStartAt = Util.formatDate(new Date()) + " 00:00";
      self.searchForm.createAtEndAt = Util.formatDate(new Date()) + " 23:59";
    } else {
      self.searchForm.createAtStartAt = Util.getCurrentMonthFirst() + " 00:00";
      self.searchForm.createAtEndAt = Util.getCurrentMonthLast() + " 23:59";
    }
    if (self.$route.query.ownerId !== 0) {
      self.searchForm.ownerIds = [self.$route.query.ownerId];
    }
    self.search();
  },
  methods: {
    search() {
      const self = this;
      self.records = [];
      self.loading = true;
      Payment.diffAmountReportForWorkBench(self.searchForm).then(function (
        res
      ) {
        self.loading = false;
        if (res.status === 200) {
          if (res.data.bargains.length != 0) {
            self.records = self.buildTableData(res.data.bargains);
            self.mergeCells = self.buildMergeCells(res.data.bargains);
          }
        } else {
          self.sysError();
        }
      });
    },

    buildTableData(bargains) {
      let rs = [];
      bargains.forEach((bg) => {
        // let obj = {
        //   id: bg.id,
        //   serialNo: bg.serialNo,
        //   customerName: bg.customerName,
        //   isBargain: true,
        // };
        // rs.push(obj); //将bargain的数据转换到格式，放到数据列表
        bg.payments.forEach((item) => {
          let obj = item;
          Vue.set(obj, "serialNo", bg.serialNo);
          Vue.set(obj, "shopId", bg.shopId);
          Vue.set(obj, "shopName", bg.shopName);
          Vue.set(obj, "settleType", bg.settleType);
          Vue.set(obj, "amount", bg.amount);
          Vue.set(obj, "currency", bg.currency);
          Vue.set(obj, "customerId", bg.customerId);
          Vue.set(obj, "customerName", bg.customerName);
          Vue.set(obj, "customerCountry", bg.customerCountry);
          Vue.set(obj, "customerProvince", bg.customerProvince);
          Vue.set(obj, "customerCity", bg.customerCity);
          Vue.set(obj, "customerAddress", bg.customerAddress);
          Vue.set(obj, "customerPhone", bg.customerPhone);
          Vue.set(obj, "customerZipcode", bg.customerZipcode);
          Vue.set(obj, "customerType", bg.customerType);
          Vue.set(obj, "customerSource", bg.customerSource);
          Vue.set(obj, "customerEmail", bg.customerEmail);
          Vue.set(obj, "deliveryRemark", bg.deliveryRemark);
          Vue.set(obj, "groupJson", bg.groupJson);
          Vue.set(obj, "remark", bg.remark);
          Vue.set(obj, "_ownerId", bg.ownerId);
          Vue.set(obj, "_ownerName", bg.ownerName);
          Vue.set(obj, "createId", bg.createId);
          Vue.set(obj, "createName", bg.createName);
          Vue.set(obj, "createAt", bg.createAt);
          Vue.set(obj, "tenantId", bg.tenantId);
          Vue.set(obj, "orders", bg.orders);
          Vue.set(obj, "payments", bg.payments);
          Vue.set(obj, "plateform", bg.plateform);
          Vue.set(obj, "plateformBargainId", bg.plateformBargainId);
          Vue.set(obj, "cnyAmount", bg.cnyAmount);
          Vue.set(obj, "replaceCustomerId", bg.replaceCustomerId);
          Vue.set(obj, "confirm", bg.confirm);
          Vue.set(obj, "lastDealtAt", bg.lastDealtAt);
          Vue.set(obj, "customer", bg.customer);
          Vue.set(obj, "productAmount", bg.productAmount);
          Vue.set(obj, "currentMonthAmount", bg.currentMonthAmount);
          Vue.set(obj, "plateformStoreId", bg.plateformStoreId);
          Vue.set(obj, "financeDeliveryAt", bg.financeDeliveryAt);
          Vue.set(obj, "deliveryAudit", bg.deliveryAudit);
          Vue.set(obj, "financeAudit", bg.financeAudit);
          Vue.set(obj, "pauseDeliveryAt", bg.pauseDeliveryAt);
          Vue.set(obj, "payAmount", bg.payAmount);
          Vue.set(obj, "productQty", bg.productQty);
          Vue.set(obj, "differAmount", bg.differAmount);
          Vue.set(obj, "ignoreAmount", bg.ignoreAmount);
          rs.push(obj);
        });
      });
      return rs;
    },
    buildMergeCells(bargains) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < bargains.length; i++) {
        mcs.push({
          row: rowIdx, //行
          col: 4,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        mcs.push({
          row: rowIdx, //行
          col: 5,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        mcs.push({
          row: rowIdx, //行
          col: 6,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        mcs.push({
          row: rowIdx, //行
          col: 7,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        mcs.push({
          row: rowIdx, //行
          col: 8,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        mcs.push({
          row: rowIdx, //行
          col: 9,
          rowspan: bargains[i].payments.length, //跨行
          colspan: 1, //跨列
        });
        rowIdx = rowIdx + bargains[i].payments.length;
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.mergeCells;
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
  },
};
</script>
